import raw from "./raw/close.svg";
import { IconBuilder } from "./builder/IconBuilder";

export const Close = IconBuilder({
    svg: raw,
    css: { "& g": { opacity: 1 } },
    colorize: color => ({ "& g": { stroke: color } })
});
